<template>
  <section id="introduction" class="gradient-violat padding-top-90 home-slider">
      <div id="home-slider" class="owl-carousel">
        <div>
          <div class="sliding-card-with-bottom-image padding-top-90">
            <h2 class="cta-heading text-white">{{introData.page_one_title}}</h2>
            <p class="text-white slider-para">{{introData.page_one_content}}</p>
            <div class="cta-btn-group">
              <!-- <a class="btn btn-orange border-none btn-rounded-corner" href="#">Download <span class="icon-on-button"><i class="ion-ios-cloud-download-outline"></i></span></a>
              <a class="btn-video text-white" href="#"><span class="icon-rounded bordered-ios"><i class="ion-ios-play-outline"></i></span>watch tutorial</a> -->
            </div>
            <div class="image-container text-center sm-display-none">
              <img class="img-responsive" src="images/mockuo2.png" alt="">
            </div>
          </div>
        </div>
        
        <div>
          <div class="container">
            <div class="row">
              <div class="showdiv1 image-right-slide-bg clearfix" style="background-image:url(images/mockuo1.png)">
                <div class="col-md-12 col2-padding">
                  <h2 class="cta-heading text-white">{{introData.page_two_title}}</h2>
                  <p class="text-white slider-para">{{introData.page_two_content}}</p>
                  <div class="cta-btn-group">
                    <!-- <a class="btn btn-orange border-none btn-rounded-corner" href="#">Download <span class="icon-on-button"><i class="ion-ios-cloud-download-outline"></i></span></a>
                    <a class="btn btn-white border-none btn-rounded-corner" href="#">Live demo<span class="icon-on-button"><i class="ion-ios-arrow-thin-right"></i></span></a> -->
                  </div>
                </div>
              </div>

            <div class="showdiv2">
              <div class="col-md-12 col2-padding">
                  <h2 class="cta-heading text-white">{{introData.page_two_title}}</h2>
                  <p class="text-white slider-para">{{introData.page_two_content}}</p>
                  <div class="cta-btn-group">
                    <!-- <a class="btn btn-orange border-none btn-rounded-corner" href="#">Download <span class="icon-on-button"><i class="ion-ios-cloud-download-outline"></i></span></a>
                    <a class="btn btn-white border-none btn-rounded-corner" href="#">Live demo<span class="icon-on-button"><i class="ion-ios-arrow-thin-right"></i></span></a> -->
                  </div>
                </div>

                <div class="image-right-slide-bg clearfix" style="background-image:url(images/mockuo1.png)"></div>
            </div>


            </div>
          </div>
        </div>
      </div>
    </section>
</template>

<script>
export default {
  name: 'intro',
  props:['introData']
}
</script>


// WEBPACK FOOTER //
// src/components/intro.vue